import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoDocumento } from '../../../models/projeto-documentos.model';
import { ProjetoDocumentoService } from '../../../services/projeto-documentos.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-projeto-documentos-list',
  templateUrl: './projeto-documentos-list.component.html',
  styleUrls: ['./projeto-documentos-list.component.scss'],
})
export class ProjetoDocumentosListComponent
  extends BaseListComponent<ProjetoDocumento>
  implements OnInit, OnDestroy
{
  @Input() idProjeto: number;
  documentoList: ProjetoDocumento[];
  type: boolean;
  permission: any;
  modalCloneRef?: BsModalRef;
  clone_title: string;

  @ViewChild('modalClone') modalClone: TemplateRef<any>;

  constructor(
    public activatedRoute: ActivatedRoute,
    private myService: ProjetoDocumentoService,
    private projetoService: ProjetoCadastroService,
    private modalService: BsModalService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.idProjeto = this.activatedRoute.parent.snapshot.params.id;
    this.type = this.activatedRoute.snapshot.data['type'];
    this.initList();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    if (this.idProjeto) {
      if (this.type) {
        this.addSub(
          this.myService.getListAllCron(this.idProjeto).subscribe((res) => {
            this.documentoList = res['list'];
            this.permission = res['permission'];
            this.loaded();
          })
        );
      } else {
        this.addSub(
          this.myService.getListAll(this.idProjeto).subscribe((res) => {
            this.documentoList = res['list'];
            this.permission = res['permission'];
            this.loaded();
          })
        );
      }
    }
  }

  novo() {
    return [
      '/pre-projeto',
      'projeto',
      this.type ? 'cronograma' : 'documentos',
      this.idProjeto,
      'adicionar',
    ];
  }

  editar(data: any) {
    return [
      '/pre-projeto',
      'projeto',
      this.type ? 'cronograma' : 'documentos',
      data.id,
    ];
  }

  download(data) {
    this.loading();
    this.addSub(
      this.myService.download(data.id).subscribe({
        next: (res) => {
          const contentDispositionHeader = res.headers.get(
            'content-disposition'
          );
          const fileName = contentDispositionHeader
            ? this.myService.extractFilename(contentDispositionHeader)
            : data?.name;
          const blob = new Blob([res.body], {
            type: 'application/octet-stream',
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          this.loaded();
        },
        error: (error) => {
          let msg;
          if (error?.status == 404) {
            msg = 'Arquivo não encontrado.';
          }
          this.msgError(msg ? msg : error?.error?.message);
          this.loaded();
        },
      })
    );
  }

  confirmExcluir() {
    this.alertConfirmation(null, 'Tem certeza que deseja excluir o projeto?').subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.projetoService.delete(this.idProjeto).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'projeto']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      },
    });
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.idProjeto && this.permission.canCloneProj) {
      const obj = {
        clone_id: this.idProjeto,
        clone_title: this.clone_title,
      };
      this.addSub(
        this.projetoService.clonar(obj).subscribe({
          next: () => {
            this.msgSuccess('Clonado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  imprimir() {
    this.loading();
    const url = `${environment.serverUrl}/rest/pre-projeto/relatorio/${this.idProjeto}`;
    this.loaded();
    window.open(url, '_blank');
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'projeto']);
  }
}